import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/calendar-icon.svg'
import _imports_1 from '@/assets/gray-user.svg'
import _imports_2 from '@/assets/pencil-gray.svg'


const _hoisted_1 = {
  key: 2,
  class: "relative"
}
const _hoisted_2 = { class: "flex flex-col gap-3 relative p-3 pt-0" }
const _hoisted_3 = {
  key: 0,
  class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow"
}
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col gap-3"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 3,
  class: "flex flex-col gap-3"
}
const _hoisted_7 = { class: "w-full flex items-center justify-between" }
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = { class: "flex items-center gap-1" }
const _hoisted_10 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_11 = { class: "flex items-center gap-1" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = { class: "text-base font-normal text-" }
const _hoisted_16 = { class: "p-3 rounded-primary-radius bg-[#e5ecf6] mt-2" }
const _hoisted_17 = { class: "text-base font-normal text-" }
const _hoisted_18 = {
  key: 4,
  class: "flex gap-1"
}
const _hoisted_19 = { class: "w-full flex items-center justify-between" }
const _hoisted_20 = { class: "flex items-center gap-3" }
const _hoisted_21 = { class: "flex items-center gap-1" }
const _hoisted_22 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_23 = { class: "flex items-center gap-1" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "mt-4 flex gap-2" }
const _hoisted_27 = { class: "text-base font-normal grow" }
const _hoisted_28 = { class: "px-3 py-[1px] rounded-primary-radius bg-[#e5ecf6] mt-2 h-fit w-fit" }
const _hoisted_29 = { class: "text-base font-normal h-fit w-fit" }
const _hoisted_30 = {
  key: 5,
  class: "flex flex-col gap-3"
}
const _hoisted_31 = { class: "w-full flex items-center justify-between" }
const _hoisted_32 = { class: "flex items-center gap-3" }
const _hoisted_33 = { class: "flex items-center gap-1" }
const _hoisted_34 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_35 = { class: "flex items-center gap-1" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "mt-4" }
const _hoisted_39 = { class: "text-base font-normal text-" }
const _hoisted_40 = { class: "p-3 rounded-primary-radius bg-[#e5ecf6] mt-2" }
const _hoisted_41 = { class: "text-base font-normal text-" }

import { ref } from "vue";
import InputModal from "../InputModal.vue";
import SlideImagesBlock from "./SlideImagesBlock.vue";
import CheckListBlock from "./CheckListBlock.vue";
import AddImageModal from "../AddImageModal.vue";
import RepeatableInput from "./RepeatableInput.vue";
import CustomAccordion from "@/components/Re-usable/Phase/CustomAccordion.vue";

type Props = {
  input: any;
  childInputs: any;
  project: string | string[];
  phase: number;
  phaseDetails: any;
  step: any;
  selectedTermins: any;
  showDetails?: boolean;
  headerClass: string;
};
type Emits = {
  (event: "refresh"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupInput',
  props: {
    input: {},
    childInputs: {},
    project: {},
    phase: {},
    phaseDetails: {},
    step: {},
    selectedTermins: {},
    showDetails: { type: Boolean },
    headerClass: {}
  },
  emits: ["refresh"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const isInputModalOpen = ref(false);
const isAddImageModalOpen = ref(false);
const selectedInput = ref<any>(null);
const selectedStep = ref<any>(null);

const toggleModalHandler: any = (input: any) => {
  selectedInput.value = input;
  selectedStep.value = props.step;
  isInputModalOpen.value = !isInputModalOpen.value;
};

/** Resolve display label for select/static_select inside groups. */
function getSelectDisplayLabel(input: any): string {
  if (input?.value == null || input?.value === "") return "";
  const val = input.value;
  const opts = input.options;
  if (!opts || !Array.isArray(opts)) return String(val);
  const byId = opts.find(
    (opt: any) =>
      Number(opt.id) === Number(val) || String(opt.id) === String(val)
  );
  if (byId) return String(byId.option ?? byId.name ?? val);
  const byText = opts.find(
    (opt: any) =>
      String(opt.option ?? "").toLowerCase() === String(val).toLowerCase() ||
      String(opt.name ?? "").toLowerCase() === String(val).toLowerCase()
  );
  if (byText) return String(byText.option ?? byText.name ?? val);
  return String(val);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isInputModalOpen.value && selectedInput.value)
      ? (_openBlock(), _createBlock(InputModal, {
          key: 0,
          input: selectedInput.value,
          step: selectedStep.value,
          "is-open": isInputModalOpen.value,
          project: __props.project,
          phase: __props.phase,
          termins: __props.phaseDetails.termins,
          onRefresh: _cache[0] || (_cache[0] = () => emits('refresh')),
          onToggleModal: _cache[1] || (_cache[1] = 
      () => {
        isInputModalOpen.value = false;
        selectedInput.value = null;
      }
    )
        }, null, 8, ["input", "step", "is-open", "project", "phase", "termins"]))
      : _createCommentVNode("", true),
    (isAddImageModalOpen.value && selectedInput.value)
      ? (_openBlock(), _createBlock(AddImageModal, {
          key: 1,
          steps: __props.phaseDetails.steps,
          termins: __props.phaseDetails.termins,
          "is-open": isAddImageModalOpen.value,
          project: __props.project,
          input: selectedInput.value,
          step: selectedStep.value,
          "header-title": selectedInput.value ? selectedInput.value.name : '',
          phase: __props.phase,
          onToggleModal: _cache[2] || (_cache[2] = ($event: any) => (isAddImageModalOpen.value = false)),
          onRefresh: _cache[3] || (_cache[3] = () => emits('refresh'))
        }, null, 8, ["steps", "termins", "is-open", "project", "input", "step", "header-title", "phase"]))
      : _createCommentVNode("", true),
    (__props.childInputs.some((input) => (input.type !== 'repeatable_input' && input.value?.length > 0) || (input.type === 'repeatable_input' && input.finishedInputs &&  input.finishedInputs > 0)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(CustomAccordion, {
            "step-id": __props.input.id,
            "step-name": __props.input.name,
            class: "observe relative bg-[#E5E4E2] rounded-primary-radius",
            "sticky-height": __props.headerClass,
            accordionHeaderColor: "#E5E4E2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (__props.childInputs.some((input) => input.type === 'checkbox'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(CheckListBlock, {
                        checklist: __props.childInputs.filter((input) => input.type === 'checkbox')
                      }, null, 8, ["checklist"])
                    ]))
                  : _createCommentVNode("", true),
                (__props.childInputs.some((input) => input.type === 'repeatable_input' && input.finishedInputs > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.childInputs.filter((input) => input.type === 'repeatable_input'), (childInput) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: childInput.id,
                          class: ""
                        }, [
                          _createVNode(RepeatableInput, {
                            showDetails: __props.showDetails,
                            step: __props.step,
                            input: childInput,
                            project: __props.project,
                            phaseDetails: __props.phaseDetails,
                            phase: __props.phase,
                            onRefresh: _cache[4] || (_cache[4] = () => emits('refresh'))
                          }, null, 8, ["showDetails", "step", "input", "project", "phaseDetails", "phase"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (__props.childInputs.some((input) => input.type === 'image' && input.value?.length > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.childInputs.filter((input) => input.type === 'image' && input.value?.length > 0), (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "flex flex-col gap-1"
                        }, [
                          _createVNode(SlideImagesBlock, {
                            "is-group": true,
                            "show-details": __props.showDetails,
                            "header-class": `${__props.showDetails ? 'top-[378px]' : 'top-[188px]'}`,
                            onAddImageModalOpen: 
                () => {
                  selectedInput.value = item;
                  selectedStep.value = __props.step;
                  isAddImageModalOpen.value = true;
                }
              ,
                            input: item,
                            step: __props.step,
                            steps: __props.phaseDetails.steps,
                            onRefresh: _cache[5] || (_cache[5] = 
                () => {
                  emits('refresh');
                }
              )
                          }, null, 8, ["show-details", "header-class", "onAddImageModalOpen", "input", "step", "steps"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (__props.childInputs.some((input) => input.type === 'text' && input.value))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.childInputs.filter((input) => input.type === 'text' && input.value), (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow flex flex-col gap-2"
                        }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _cache[6] || (_cache[6] = _createElementVNode("img", {
                                  class: "w-3 h-3 cursor-pointer",
                                  src: _imports_0,
                                  alt: "Calendar"
                                }, null, -1)),
                                _createElementVNode("p", _hoisted_10, _toDisplayString(item.createdAt
                        ? new Date(item.createdAt).toLocaleDateString("de")
                        : ""), 1)
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                _cache[7] || (_cache[7] = _createElementVNode("img", {
                                  class: "w-3 h-3",
                                  src: _imports_1,
                                  alt: "User"
                                }, null, -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.workers, (worker, index) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: index,
                                    class: "text-sm text-[#898790] foont-medium"
                                  }, [
                                    _createTextVNode(_toDisplayString(worker.fullname), 1),
                                    (index < item.workers.length - 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, ","))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("img", {
                              onClick: ($event: any) => (toggleModalHandler(item)),
                              class: "w-4 h-4 cursor-pointer",
                              src: _imports_2,
                              alt: "Pencil"
                            }, null, 8, _hoisted_13)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("p", _hoisted_15, _toDisplayString(item.name), 1),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("p", _hoisted_17, _toDisplayString(item.value), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (__props.childInputs.some((input) => input.type === 'number' && input.value))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.childInputs.filter((input) => input.type === 'number' && input.value), (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "p-3 w-1/3 bg-white rounded-primary-radius shadow-primary-box-shadow"
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _cache[8] || (_cache[8] = _createElementVNode("img", {
                                  class: "w-3 h-3 cursor-pointer",
                                  src: _imports_0,
                                  alt: "Calendar"
                                }, null, -1)),
                                _createElementVNode("p", _hoisted_22, _toDisplayString(item.createdAt
                        ? new Date(item.createdAt).toLocaleDateString("de")
                        : ""), 1)
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _cache[9] || (_cache[9] = _createElementVNode("img", {
                                  class: "w-3 h-3",
                                  src: _imports_1,
                                  alt: "User"
                                }, null, -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.workers, (worker, index) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: index,
                                    class: "text-sm text-[#898790] foont-medium"
                                  }, [
                                    _createTextVNode(_toDisplayString(worker.fullname), 1),
                                    (index < item.workers.length - 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, ","))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("img", {
                              onClick: ($event: any) => (toggleModalHandler(item)),
                              class: "w-4 h-4 cursor-pointer",
                              src: _imports_2,
                              alt: "Pencil"
                            }, null, 8, _hoisted_25)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("p", _hoisted_27, _toDisplayString(item.name), 1),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("p", _hoisted_29, _toDisplayString(item.value), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (__props.childInputs.some((input) => (input.type === 'select' || input.type === 'static_select') && input.value ))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.childInputs.filter((input) => (input.type === 'select' || input.type === 'static_select') && input.value), (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow flex flex-col gap-2"
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _cache[10] || (_cache[10] = _createElementVNode("img", {
                                  class: "w-3 h-3 cursor-pointer",
                                  src: _imports_0,
                                  alt: "Calendar"
                                }, null, -1)),
                                _createElementVNode("p", _hoisted_34, _toDisplayString(item.createdAt
                        ? new Date(item.createdAt).toLocaleDateString("de")
                        : ""), 1)
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _cache[11] || (_cache[11] = _createElementVNode("img", {
                                  class: "w-3 h-3",
                                  src: _imports_1,
                                  alt: "User"
                                }, null, -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.workers, (worker, index) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: index,
                                    class: "text-sm text-[#898790] foont-medium"
                                  }, [
                                    _createTextVNode(_toDisplayString(worker.fullname), 1),
                                    (index < item.workers.length - 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, ","))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("img", {
                              onClick: ($event: any) => (toggleModalHandler(item)),
                              class: "w-4 h-4 cursor-pointer",
                              src: _imports_2,
                              alt: "Pencil"
                            }, null, 8, _hoisted_37)
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("p", _hoisted_39, _toDisplayString(item.name), 1),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("p", _hoisted_41, _toDisplayString(getSelectDisplayLabel(item)), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["step-id", "step-name", "sticky-height"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})